import React from 'react';

export default function AboutExhibition(props) {
    return (
        <div className="exhibition d-flex flex-column flex-md-row justify-content-center justify-content-md-start align-items-md-start align-items-center gap-md-4 gap-3">
            <div className="exhibition-image-side">
                <img src={props.exbImg} alt={props.exbTitle} />
            </div>
            <div className="exhibition-details-side">
                <h4 className='text-center text-md-start'>{props.exbTitle}</h4>
                <p className='text-center text-md-start'>{props.exbDesc}</p>
            </div>
        </div>
    )
}
